// App.js - WEB
import React, {PureComponent} from "react";
import {View, Text, Button, FlatList, TouchableOpacity, Linking, Platform, I18nManager, Keyboard} from "react-native";
//import {ModalContainer} from "react-router-modal";
import {connect, Provider} from "react-redux";
import store from "../../redux/store";
import HomeScreen from "../../web/screens/HomeScreen";
import {
    NavigationContainer,
    DefaultTheme as NavigationDefaultTheme,
    DarkTheme as NavigationDarkTheme,
    LinkingOptions
} from '@react-navigation/native';
import {createDrawerNavigator} from '@react-navigation/drawer';
import SecondScreen from "../../web/screens/SecondScreen";
import {createStackNavigator} from '@react-navigation/stack';
import {createBottomTabNavigator} from '@react-navigation/bottom-tabs';

import {enableScreens} from 'react-native-screens';
import SplashScreen, {
    serviceActionSetConnectionType,
    serviceActionSetToken, serviceActionSetUser,
    serviceActionTokenFirebase,

} from "../../screens/137/splash/action/ActionSplashGetAllData";
import AsyncStorage from '@react-native-community/async-storage';

import {typeExport} from "../../redux/store/type";
import {navigationRef} from "../../redux/NavigationService";
import {AsyngStorageClass} from "../../tools/AsyngStorageClass";
import {Tools} from "../../tools/Tools";
import NetInfo from "@react-native-community/netinfo";
import {serviceActionSetIsConnected} from "../../screens/satia/splash/action/ActionSplashSatiaScreen";
import ListNewsScreen from "../../screens/137/main/news/action/ActionListNewsScreen";

import EnterCodeScreen from "../../screens/137/login/code/action/ActionEnterCodeScreen";
import InformationScreen from "../../screens/137/login/informaion/action/ActionInformationScreen";
import LoginEnterPhoneScreen from "../../screens/137/login/loginUsername/action/ActionLoginEnterPhoneScreen";
import LoginScreen from "../../screens/137/login/action/ActionLoginScreen";
import LoginEnterPhoneCodeScreen from "../../screens/137/login/loginMobile/action/ActionLoginEnterPhoneCodeScreen";

import MainScreen from "../../screens/137/main/MainScreen";
import MenuDrawer from "../../drawer/right/MenuDrawer";
import SatiaScreen from "../../screens/common/contactUs/SatiaScreen";
import ShowMap from "../../screens/common/map/ShowMap";
import WebViewScreen from "../../screens/common/webview/WebViewScreen";
import ApplyScreen from "../../screens/137/main/applay/action/ActionApplyScreen";
import DetailsScreen from "../../screens/137/main/details/action/ActionDetailsScreen";
import CategoryScreen from "../../screens/137/main/category/action/ActionCategoryScreen";
import AdvancedSearchScreen from "../../screens/137/main/pageGraveyard/AdvancedSearchScreen";
import DetailsDeadScreen from "../../screens/137/main/pageGraveyard/DetailsDeadScreen";
import ListDeadScreen from "../../screens/137/main/pageGraveyard/action/ActionListDeadScreen";
import ListMyApplyScreen from "../../screens/137/main/applay/action/ActionListMyApplysScreen";
import ListMyRegisterComplaintsScreen from "../../screens/137/main/applay/action/ActionListMyRegisterComplaintsScreen";
import SubmitRequestScreen22 from "../../screens/137/main/applay/submitRequest/action/ActionSubmitRequestScreen22";
import DetailsRequestScreen from "../../screens/137/main/applay/action/ActionDetailsRequestScreen";
import ProfileScreen from "../../screens/137/main/profile/ProfileScreen";
import RegisterComplaintsScreen
    from "../../screens/137/main/applay/submitComplaint/action/ActionRegisterComplaintsScreen";
import DetailsRegisterComplaintsScreen from "../../screens/137/main/applay/DetailsRegisterComplaintsScreen";
import ChangePassScreen from "../../screens/137/login/changePass/action/ActionChangPssScreen";
import ChangeInformationScreen from "../../screens/137/login/changeInformatin/action/ActionChangeInformationScreen";
import ListMyApplyOperationScreen from "../../screens/137/main/applay/action/ActionListMyApplysOperationScreen";
import ListOperatorApplyScreen from "../../screens/137/main/applay/action/ActionListOperatorApplysScreen";
import DetailsOperatorApplyScreen from "../../screens/137/main/applay/action/ActionDetailsOperatorApplyScreen";
import SubmitSwitchingOperationScreen
    from "../../screens/137/main/applay/submitSwitch/action/ActionSubmitSwitchingOperationScreen";
import GalleryServiceOperationScreen from "../../screens/137/main/applay/action/ActionGalleryServiceOperationScreen";
import GalleryServiceScreen from "../../screens/137/main/applay/action/ActionGalleryServiceScreen";
import ShahrbanSatiaScreen from "../../screens/common/contactUs/ShahrbanSatiaScreen";
import DetailsGalleryServiceScreen from "../../screens/137/main/applay/DetailsGalleryServiceScreen";
import DetailsGalleryServiceOperationScreen from "../../screens/137/main/applay/DetailsGalleryServiceOperationScreen";
import ChatMessageScreen from "../../screens/common/chat/ChatMessageScreen";
import ListMessageChatScreen from "../../screens/common/chat/action/ActionListMessageChatScreen";
import ListUserChatScreen from "../../screens/common/chat/action/ActionListUserChatScreen";


enableScreens();

const theme = {
    ...NavigationDarkTheme,
    // ...PaperDarkTheme,
    colors: {
        ...NavigationDarkTheme.colors,
        // ...PaperDarkTheme.colors,
        background: '#f0f0f0',
        text: '#ffffff'
    }
};
const HomeStack = createStackNavigator();

function HomeStackScreen() {

    return (
        <HomeStack.Navigator
            initialRouteName="MainScreen"
            screenOptions={{
                headerTitleAlign: 'center',
                headerStyle: {
                    backgroundColor: '#621FF7',
                },
                headerTintColor: '#fff',
                headerTitleStyle: {
                    fontWeight: 'bold',
                },
                headerShown: false

            }}
        >
            <HomeStack.Screen name="MainScreen" component={MainScreen}/>
            <HomeStack.Screen name="SatiaScreen" component={SatiaScreen}/>
            <HomeStack.Screen name="ShowMap" component={ShowMap}/>
            <HomeStack.Screen name="WebViewScreen" component={WebViewScreen}/>
            <HomeStack.Screen name="ListNewsScreen" component={ListNewsScreen}/>
            <HomeStack.Screen name="ApplyScreen" component={ApplyScreen}/>
            <HomeStack.Screen name="DetailsScreen" component={DetailsScreen}/>
            <HomeStack.Screen name="CategoryScreen" component={CategoryScreen}/>
            <HomeStack.Screen name="AdvancedSearchScreen" component={AdvancedSearchScreen}/>
            <HomeStack.Screen name="DetailsDeadScreen" component={DetailsDeadScreen}/>
            <HomeStack.Screen name="ListDeadScreen" component={ListDeadScreen}/>
            <HomeStack.Screen name="ListMyApplyScreen" component={ListMyApplyScreen}/>
            <HomeStack.Screen name="ListMyRegisterComplaintsScreen" component={ListMyRegisterComplaintsScreen}/>
            <HomeStack.Screen name="SubmitRequestScreen" component={SubmitRequestScreen22}/>
            <HomeStack.Screen name="DetailsRequestScreen" component={DetailsRequestScreen}/>
            <HomeStack.Screen name="ProfileScreen" component={ProfileScreen}/>
            <HomeStack.Screen name="RegisterComplaintsScreen" component={RegisterComplaintsScreen}/>
            <HomeStack.Screen name="DetailsRegisterComplaintsScreen" component={DetailsRegisterComplaintsScreen}/>
            <HomeStack.Screen name="ChangePassScreen" component={ChangePassScreen}/>
            <HomeStack.Screen name="ChangeInformationScreen" component={ChangeInformationScreen}/>
            <HomeStack.Screen name="GalleryServiceScreen" component={GalleryServiceScreen}/>
            <HomeStack.Screen name="ShahrbanSatiaScreen" component={ShahrbanSatiaScreen}/>
            {/*<HomeStack.Screen name="LoginStackScreen" component={LoginStackScreen}/>*/}
            {/*  <HomeStack.Screen name="LoginEnterPhoneCodeScreen"
                               component={LoginEnterPhoneCodeScreen}/>
            <HomeStack.Screen name="EnterCodeScreen"
                               component={EnterCodeScreen}/>
            <HomeStack.Screen name="InformationScreen"
                               component={InformationScreen}/>
            <HomeStack.Screen name="LoginEnterPhoneScreen"
                               component={LoginEnterPhoneScreen}/>
            <HomeStack.Screen name="LoginScreen"
                               component={LoginScreen}/>*/}
        </HomeStack.Navigator>
    );
};

const LoginStack = createStackNavigator();

function LoginStackScreen() {

    return (
        <LoginStack.Navigator
            initialRouteName="LoginEnterPhoneScreen"
            screenOptions={{
                headerTitleAlign: 'center',
                headerStyle: {
                    backgroundColor: '#621FF7',
                },
                headerTintColor: '#fff',
                headerTitleStyle: {
                    fontWeight: 'bold',
                },
                headerShown: false
            }}

        >
            <LoginStack.Screen name="LoginEnterPhoneCodeScreen"
                               component={LoginEnterPhoneCodeScreen}/>
            <LoginStack.Screen name="EnterCodeScreen"
                               component={EnterCodeScreen}/>
            <LoginStack.Screen name="InformationScreen"
                               component={InformationScreen}/>
            <LoginStack.Screen name="LoginEnterPhoneScreen"
                               component={LoginEnterPhoneScreen}/>
            <LoginStack.Screen name="LoginScreen"
                               component={LoginScreen}/>
            <LoginStack.Screen name="ChangePassScreen" component={ChangePassScreen}/>

            {/*
            <HomeStack.Screen name="SecondScreen" component={SecondScreen}/>
*/}

        </LoginStack.Navigator>
    );
};


const linking = {
    prefixes: [
        'https://app.example.com'
        /* your linking prefixes */
    ],
    config: {
        screens: {
            initialRouteName: 'SplashSatiaScreen',

            SplashSatiaScreen: 'splash',
            LoginStack: {
//rout/login
                path: 'rout',
                screens: {
                    LoginEnterPhoneCodeScreen: 'login',
                    exact: true,

                }

            },
            DrawerScreen: {
//drawer
                path: 'drawer',
                screens: {
                    LoginStackScreen: {
                        //drawer/login_Stack
                        path: 'login_Stack',
                        screens: {
                            //drawer/login_Stack/login
                            LoginEnterPhoneCodeScreen: 'login',
                            exact: true,

                        }

                    },
                    HomeStackScreen: {
                        //drawer/home_Stack
                        path: 'home_Stack',
                        screens: {
                            //drawer/home_Stack/shahrbanSatia

                            ShahrbanSatiaScreen: 'shahrbanSatia',
                            exact: true,

                        }

                    },

                }

            },
            ListAccountSatiaScreen: 'accounts',
            DetailsGalleryServiceScreen_Root: {
                path: 'details_gallery/:id',
                // parse: {
                //     id: (id) => `user-${id}`,
                // },
                // stringify: {
                //     id: (id) => id.replace(/^user-/, ''),
                // },
            },
            DetailsGalleryServiceOperationScreen_Root: {
                path: 'details_gallery_operation/:id',
                // parse: {
                //     id: (id) => `user-${id}`,
                // },
                // stringify: {
                //     id: (id) => id.replace(/^user-/, ''),
                // },
            },
            ChatScreen_Root: {
                path: 'chat',
                // parse: {
                //     id: (id) => `user-${id}`,
                // },
                // stringify: {
                //     id: (id) => id.replace(/^user-/, ''),
                // },
            },
            GalleryServiceOperationScreen_Root: {
                path: 'list_gallery_operation',
                // parse: {
                //     id: (id) => `user-${id}`,
                // },
                // stringify: {
                //     id: (id) => id.replace(/^user-/, ''),
                // },
            },
            GalleryServiceScreen_Root: {
                path: 'list_gallery',
                // parse: {
                //     id: (id) => `user-${id}`,
                // },
                // stringify: {
                //     id: (id) => id.replace(/^user-/, ''),
                // },
            },
            DetailsOperatorApplyScreen_Root: {
                path: 'details_request_operation',
                // parse: {
                //     id: (id) => `user-${id}`,
                // },
                // stringify: {
                //     id: (id) => id.replace(/^user-/, ''),
                // },
            },
            // DrawerScreen: {
            //
            //     path: 'drawer',
            //     screens: {
            //         HomeStackScreen: {
            //
            //             path: 'home',
            //             /*   screens: {
            //                    MainSatiaScreen: 'main',
            //
            //                }*/
            //
            //         }
            //
            //     }
            //
            // }


        }

    },

};

const OperationStack = createStackNavigator();

function OperationStackScreen() {

    return (
        <OperationStack.Navigator
            initialRouteName="ApplyScreen"
            screenOptions={{
                headerTitleAlign: 'center',
                headerStyle: {
                    backgroundColor: '#621FF7',
                },
                headerTintColor: '#fff',
                headerTitleStyle: {
                    fontWeight: 'bold',
                },
                headerShown: false

            }}
        >
            <OperationStack.Screen name="ApplyScreen" component={ApplyScreen}/>
            <OperationStack.Screen name="ListMyApplyOperationScreen" component={ListMyApplyOperationScreen}/>
            <OperationStack.Screen name="ListOperatorApplyScreen" component={ListOperatorApplyScreen}/>

            <OperationStack.Screen name="MainScreen" component={MainScreen}/>
            <OperationStack.Screen name="SatiaScreen" component={SatiaScreen}/>
            <OperationStack.Screen name="ShowMap" component={ShowMap}/>
            <OperationStack.Screen name="WebViewScreen" component={WebViewScreen}/>
            <OperationStack.Screen name="ListNewsScreen" component={ListNewsScreen}/>
            <OperationStack.Screen name="DetailsScreen" component={DetailsScreen}/>
            <OperationStack.Screen name="CategoryScreen" component={CategoryScreen}/>
            <OperationStack.Screen name="AdvancedSearchScreen" component={AdvancedSearchScreen}/>
            <OperationStack.Screen name="DetailsDeadScreen" component={DetailsDeadScreen}/>
            <OperationStack.Screen name="ListDeadScreen" component={ListDeadScreen}/>
            <OperationStack.Screen name="ListMyApplyScreen" component={ListMyApplyScreen}/>
            <OperationStack.Screen name="ListMyRegisterComplaintsScreen" component={ListMyRegisterComplaintsScreen}/>
            <OperationStack.Screen name="SubmitRequestScreen" component={SubmitRequestScreen22}/>
            <OperationStack.Screen name="DetailsRequestScreen" component={DetailsRequestScreen}/>
            <OperationStack.Screen name="ProfileScreen" component={ProfileScreen}/>
            <OperationStack.Screen name="RegisterComplaintsScreen" component={RegisterComplaintsScreen}/>
            <OperationStack.Screen name="DetailsRegisterComplaintsScreen" component={DetailsRegisterComplaintsScreen}/>
            <OperationStack.Screen name="ChangePassScreen" component={ChangePassScreen}/>
            <OperationStack.Screen name="ChangeInformationScreen" component={ChangeInformationScreen}/>
            <OperationStack.Screen name="DetailsOperatorApplyScreen" component={DetailsOperatorApplyScreen}/>
            <OperationStack.Screen name="SubmitSwitchingOperationScreen" component={SubmitSwitchingOperationScreen}/>
            <OperationStack.Screen name="GalleryServiceOperationScreen" component={GalleryServiceOperationScreen}/>
            <OperationStack.Screen name="ListUserChatScreen" component={ListUserChatScreen}/>
            <OperationStack.Screen name="ListMessageChatScreen" component={ListMessageChatScreen}/>
        </OperationStack.Navigator>
    );
};


const Drawer = createDrawerNavigator();
const DrawerScreen = () => (
    <Drawer.Navigator
        initialRouteName="HomeStackScreen"
        screenOptions={{

            headerShown: false
        }}

        drawerContent={props => <MenuDrawer {...props}

        />}>


        {/*<Drawer.Screen name="MainSatiaScreen" component={MainSatiaScreen}/>*/}
        <Drawer.Screen name="HomeStackScreen" component={HomeStackScreen}/>
        <Drawer.Screen name="LoginStackScreen" component={LoginStackScreen}/>


        {/*    <Drawer.Screen name="HomeDrawer" component={HomeScreen}/>
        <Drawer.Screen name="SupportScreen" component={SecondScreen}/>*/}
        {/*<Drawer.Screen name="UserScreen" component={UserScreen}/>*/}
        {/*<Drawer.Screen name="HomeScreen" component={HomeScreen}/>*/}
    </Drawer.Navigator>
);
const RootStack = createStackNavigator();

function Home() {
    return (
        <Tab.Navigator>

            <Tab.Screen name="Profile" component={HomeScreen}/>
            <Tab.Screen name="Feed" component={SecondScreen}/>
        </Tab.Navigator>
    );
}

const SplashStack = createStackNavigator();
const Tab = createBottomTabNavigator();
let token = null;
let container = null;

/*const storage = Platform.select({
    web: () => require("localforage"),
    android: () => require("@react-native-community/async-storage").default,
    ios: () => require("@react-native-community/async-storage").default
})();*/
class RouterSatia extends PureComponent {
    constructor(props) {
        super(props);
        container = this;
        this.state = {

            modalHeight: 0,
            oneDoLocation: true

        };
        /*     Tools.getCurrentPosition(
                 "ShowMap",
                 null,
                 null,
                 this.goScreen,
                 this.stateError,
                 "Parent"`1`
             );*/
        global.MyVar = 'https://aboutreact.com';
    }


    async componentWillMount() {

        token = await AsyngStorageClass.checkToken();
        if (token) {
            store.dispatch(serviceActionSetToken(token));

            let user = await AsyngStorageClass.getASyng(typeExport._USER);
            store.dispatch(serviceActionSetUser(user))

            /*    let account = await AsyngStorageClass.getASyng("Account");
                store.dispatch(serviceActionAccount(account, 0));*/
        }


        let token_fb = await AsyncStorage.getItem('fcmToken');

        store.dispatch(serviceActionTokenFirebase(token_fb));

        /* let l = await AsyncStorage.getItem(typeExport.LANG);

         // store.dispatch(serviceActionSetTypeLogin(typeExport._TypeLogin, t)

         i18n.locale = (l)
         //  alert("fgsfgfgf")

         if (l != 'fa') {
             //i18n.locale = 'fa';
             //i18n.locale = 'fa';
             if (l != 'en') {
                 if (!I18nManager.getConstants().isRTL) {
                     await I18nManager.forceRTL(true);
                 }
             } else {
                 if (I18nManager.getConstants().isRTL) {
                     await I18nManager.forceRTL(false);
                 }
             }
             await AsyncStorage.setItem(typeExport.LANG, 'fa');
             if (Platform.OS !== "web")
                 RNRestart.Restart()
             {
                 window.location.reload();

             }

         }
         if (Platform.OS === "web") {
             //  alert("fggf")
             await I18nManager.forceRTL(l == 'fa');

         }*/
    }

    componentWillReceiveProps(props) {

    }

    async componentDidMount() {


        // golbal._weatherCity
        let checkLogin = (store.getState().reducerSplashGetAllData.TypeLogin == 2)

        // this.keyboardDidShowListener = Keyboard.addListener('keyboardDidShow', this._keyboardDidShow);
        // this.keyboardDidHideListener = Keyboard.addListener('keyboardDidHide', this._keyboardDidHide);
        // container.toast.setKeyboardHeight(0)
        let Conn = false;

        const dispatchConnected = state => {
            let isConnected = state.isConnected
            this.props.setIsConnected(isConnected);
            store.dispatch(serviceActionSetConnectionType(state))

            /*   if (Platform.OS === "android")
                   this.checkSatusWifi()*/
            Conn = isConnected;
            if (isConnected && this.state.oneDoLocation ) {

                this.setState({
                        oneDoLocation: false
                    },
                    () => {

                        Tools.checkPermission(
                            "ShowMap",
                            null,
                            null,
                            this.goScreen,
                            this.stateError,
                            "Parent"
                        );
                    }
                )

            }


            if (isConnected && !checkLogin)
                Tools.RequestSubmit("POST", typeExport._baseUrlSaina, null, 5)
        }


        NetInfo.addEventListener(dispatchConnected);

        /*    if (Platform.OS !== 'ios'
            )
            {
                Tools.checkPermission(
                    "ShowMap",
                    null,
                    null,
                    this.goScreen,
                    this.stateError,
                    "Parent"
                );
            }*/

        if (Platform.OS !== 'ios' && !checkLogin)
            Tools.RequestSubmit("POST", typeExport._baseUrlSaina, null, 5)
    }

/////////////////////////////////////////


    goScreen(position) {
        container.setState({oneDoLocation: true})
        //   store.dispatch(serviceActionSetLocation(position))
        //NavigationService.navigateParams("SelectMap", {item: position})
    }

    stateError() {
        container.setState({
            oneDoLocation: true,
            //    locationEnabled: false,
            //  isLoading: false,
        }, () => {
        })
    }

    checkSatusWifi() {
        wifi.isEnabled((isEnabled) => {
            store.dispatch(serviceActionSetwifiIsEnabled(isEnabled))


            wifi.connectionStatus((isConnected) => {
                store.dispatch(serviceActionSetwifiConnectionStatus(isConnected))

            });

        });

    }

    render() {
        return (


            //  {/*    <View style={[{position: 'absolute', top: 0, bottom: 0, right: 0, left: 0}]}>*/}

            <NavigationContainer ref={navigationRef} theme={theme} linking={linking}>
                <RootStack.Navigator headerMode="none" initialRouteName="SplashScreen">


                    {
                        // (this.props.TypeLogin === 2 ? !this.props.resultsShahrdar : !this.props.results) ?
                        //
                        //     (!this.props.token && this.props.TypeLogin === 2 ?
                        //         <RootStack.Screen name="LoginStack" component={LoginStackScreen}/>
                        //         :
                        //         <RootStack.Screen name="SplashScreen" component={SplashScreen}/>)
                        //     :
                        //     (this.props.TypeLogin === 2 ?
                        //             <RootStack.Screen options={{headerShown: false}} name="OperationStack"
                        //                               component={OperationStackScreen}/>
                        //             :
                        //             <RootStack.Screen options={{headerShown: false}} name="DrawerScreen"
                        //                               component={DrawerScreen}/>
                        //     )
                    }

                    {


                            // (!this.props.token  ?
                            //     <RootStack.Screen name="LoginStack" component={LoginStackScreen}/>
                            //     :
                            //     !this.props.resultsShahrdar  ?
                            //     <RootStack.Screen name="SplashScreen" component={SplashScreen}/>
                            //         :
                            //         (
                            //             <RootStack.Screen options={{headerShown: false}} name="OperationStack"
                            //                               component={OperationStackScreen}/>
                            //
                            //         )
                            //
                            // )

                    }
                    <RootStack.Screen name="SplashScreen" component={SplashScreen}/>
                    <RootStack.Screen options={{headerShown: false}} name="DrawerScreen"
                                      component={OperationStackScreen}/>
                    <RootStack.Screen name="LoginStackScreen" component={LoginStackScreen}/>

                    <RootStack.Screen name="DetailsGalleryServiceScreen_Root" component={DetailsGalleryServiceScreen}/>
                    <RootStack.Screen name="DetailsGalleryServiceOperationScreen_Root"
                                      component={DetailsGalleryServiceOperationScreen}/>
                    <RootStack.Screen name="ChatScreen_Root" component={ChatMessageScreen}/>
                    <RootStack.Screen name="GalleryServiceOperationScreen_Root"
                                      component={GalleryServiceOperationScreen}/>
                    <RootStack.Screen name="GalleryServiceScreen_Root" component={GalleryServiceScreen}/>
                    <RootStack.Screen name="DetailsOperatorApplyScreen_Root" component={DetailsOperatorApplyScreen}/>
                    <RootStack.Screen name="ListUserChatScreen_Root" component={ListUserChatScreen}/>
                    <RootStack.Screen name="ListMessageChatScreen_Root" component={ListMessageChatScreen}/>
                    {/*   <RootStack.Screen name="LoginStack" component={LoginStackScreen}/>
                    <RootStack.Screen options={{headerShown: false}} name="DrawerScreen"
                                      component={DrawerScreen}/>*/}
                </RootStack.Navigator>

            </NavigationContainer>
            // /*     </View>*/

        );
    }
}

const mapStateToProps = state => ({
    token: state.reducerSplashGetAllData.token,
    resultsShahrdar: state.reducerSplashGetAllData.resultsShahrdar,
    resultsSatia: state.reducerSplashGetAllData.resultsSatia,
    results: state.reducerSplashGetAllData.results,
    user: state.reducerSplashGetAllData.user,
    Account: state.reducerSplashGetAllData.Account,
    DataSplashScreen: state.reducerSplashGetAllData,
    TypeLogin: state.reducerSplashGetAllData.TypeLogin,
});
const mapDispatchToProps = dispatch => {
    return {
        setIsConnected: (data) => dispatch(serviceActionSetIsConnected(data)),

    }
};
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(RouterSatia);
